<script>
import RadioGroup from 'element-ui/lib/radio-group';

export default RadioGroup;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/radio-group.css';
@import '../../stylesheets/utils/utils';
// Adding RTL support to element's input
</style>
